import PropTypes from 'prop-types';

export default {
  minT: PropTypes.number,
  maxT: PropTypes.number,
  isRFID: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  setOnDevice: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  rfidCards: PropTypes.array,
  timestamp: PropTypes.string
};
